export default __webpack_public_path__ + "static/media/CMS_Users.6c64d58d.svg";